import { create } from 'zustand'
import { produce } from 'immer'
import _ from 'lodash'

export const useHubAgenda = create((set) => ({
  data: {
    details: {},
    heatMap: {},
    hours: [],
    heatMapDates: [],
  },
  actions: {
    setDetails: (date, data) =>
      set((state) =>
        produce(state, (draft) => {
          _.set(draft.data.details, date, data)
        }),
      ),
    setHeatMap: (date, data) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.heatMap[date] = data
        }),
      ),
    setHeatMapDates: (dates = []) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.heatMapDates = _.castArray(dates)
        }),
      ),
    setHours: (hours) =>
      set((state) =>
        produce(state, (draft) => {
          const currentHours = state.data.hours
          draft.data.hours = _.uniq([...currentHours, ..._.castArray(hours)])
        }),
      ),
    setClearHours: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.hours = []
        }),
      ),
  },
}))
